/* AWARE · Adicionar rápido — 20/10/2026
   Substitui o inline-size-picker.js (a caixinha por cima do botão "Escolher opções").
   Ao carregar em "Escolher opções" numa coleção, na pesquisa ou nos produtos complementares,
   sobe do fundo do ecrã uma janela (como na Mister Tuga) com:
     - foto, nome e preço do produto + faixa de fotos;
     - botões grandes para o tamanho (e para a cor, quando existe), com os esgotados riscados;
     - botão preto "Adicionar ao carrinho · preço";
     - bandeira de Portugal "Enviado a <dia>" (hoje + 3 dias úteis) e "Envios grátis";
     - "Guia de tamanhos" (o mesmo guia da página do produto, carregado só quando a janela abre).
   Depois de adicionar, fecha e abre o carrinho lateral já atualizado.
   Produtos de tamanho único: adiciona logo, sem janela.
   Configuração vinda do tema (layout/theme.liquid): window.AWARE_RAPIDO = { guiaJs, guiaCss, tabelas, editor }.
*/
(function () {
  'use strict';
  if (window.__awAdicionarRapido) { return; }
  window.__awAdicionarRapido = true;

  var CFG = window.AWARE_RAPIDO || {};
  var DIAS_ENVIO = 3;                       /* dias úteis até a encomenda sair */
  var SIZE = /^(tamanho|tamanhos|size|sizes|talla|taille)/i;
  var COR = /^(cor|cores|colou?r|couleur)/i;
  var ACESSORIO = /gorro|chap[eé]u|cachecol|bon[eé]|chinelo/i;   /* sem guia de tamanhos (igual à página do produto) */
  var TXT = {
    escolhe: 'Escolhe o tamanho',
    escolheVarios: 'Escolhe as opções',
    adicionar: (window.variantStrings && window.variantStrings.addToCart) || 'Adicionar ao carrinho',
    aAdicionar: 'A adicionar…',
    indisponivel: 'Indisponível',
    esgotado: 'Esgotado',
    erro: 'Não foi possível adicionar. Tenta outra vez.',
    guia: 'Guia de tamanhos',
    enviado: 'Enviado a',
    gratis: 'Envios grátis',
    fechar: 'Fechar',
    desde: 'desde '
  };

  /* ====== CSS ====== */
  var css = '' +
    '.aw-r{position:fixed;inset:0;z-index:1200;display:flex;align-items:flex-end;justify-content:center;font-family:var(--font-body-family,Poppins,sans-serif);color:#121212;-webkit-text-size-adjust:100%}' +
    '.aw-r[hidden]{display:none}' +
    '.aw-r__fundo{position:absolute;inset:0;background:rgba(18,18,18,.5);opacity:0;transition:opacity .25s ease}' +
    '.aw-r__folha{position:relative;width:100%;max-height:calc(100% - 40px);margin:0;padding:10px 16px calc(20px + env(safe-area-inset-bottom,0px));box-sizing:border-box;' +
      'background:#fff;border-radius:24px 24px 0 0;box-shadow:0 -12px 40px rgba(0,0,0,.18);display:flex;flex-direction:column;overflow-y:auto;overscroll-behavior:contain;' +
      'transform:translateY(100%);transition:transform .32s cubic-bezier(.2,.8,.2,1)}' +
    '.aw-r.is-aberta .aw-r__fundo{opacity:1}.aw-r.is-aberta .aw-r__folha{transform:none}' +
    '.aw-r__pega{align-self:center;flex:none;width:40px;height:4px;border-radius:4px;background:#d9d9d9;margin-bottom:14px}' +
    '.aw-r__topo{display:flex;gap:12px;align-items:center}' +
    '.aw-r__img{flex:none;width:60px;height:60px;border-radius:12px;object-fit:cover;background:#f3f3f3}' +
    '.aw-r__nome-preco{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}' +
    '.aw-r__nome{margin:0;font-size:15px;font-weight:700;line-height:1.25;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
    '.aw-r__preco{margin:0;font-size:15px;font-weight:700;line-height:1.3;display:flex;gap:8px;align-items:baseline;flex-wrap:wrap}' +
    '.aw-r__preco s{font-weight:500;color:#5c5c5c}.aw-r__preco s[hidden]{display:none}' +
    '.aw-r__x{flex:none;width:44px;height:44px;border-radius:999px;border:0;background:#f3f3f3;padding:0;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#121212}' +
    '.aw-r__x:hover{background:#e8e8e8}' +
    '.aw-r__fotos{display:flex;gap:8px;overflow-x:auto;margin:14px -16px 0;padding:0 16px;scrollbar-width:none;-webkit-overflow-scrolling:touch}' +
    '.aw-r__fotos::-webkit-scrollbar{display:none}.aw-r__fotos[hidden]{display:none}' +
    '.aw-r__fotos img{flex:0 0 112px;width:112px;height:112px;border-radius:12px;object-fit:cover;background:#f3f3f3}' +
    '.aw-r__grupo{margin:12px 0 0;min-width:0}' +
    '.aw-r__grupo-topo{display:flex;align-items:center;justify-content:space-between;gap:10px;min-height:32px;margin-bottom:8px}' +
    '.aw-r__rotulo{min-width:0;font-size:14px;font-weight:600;line-height:1.3}.aw-r__rotulo span{font-weight:500;color:#5c5c5c;white-space:nowrap}' +
    '.aw-r__guia{display:inline-flex;align-items:center;gap:6px;min-height:36px;padding:0;border:0;background:none;color:#121212;font-family:inherit;font-size:12.5px;font-weight:600;text-decoration:underline;text-underline-offset:3px;cursor:pointer;white-space:nowrap;flex:none}' +
    '.aw-r__valores{display:grid;grid-template-columns:repeat(auto-fill,minmax(64px,1fr));gap:8px}' +
    '.aw-r__valores--numeros{grid-template-columns:repeat(5,minmax(0,1fr))}' +
    '.aw-r__valores--texto{display:flex;flex-wrap:wrap}.aw-r__valores--texto .aw-r__valor{padding:0 14px}' +
    '.aw-r__valor{min-height:48px;border-radius:12px;border:1.5px solid #d4d4d4;background:#fff;color:#121212;font-family:inherit;font-size:15px;font-weight:600;line-height:1.2;padding:0 4px;cursor:pointer;transition:border-color .15s,background .15s,color .15s}' +
    '.aw-r__valor:hover{border-color:#121212}' +
    '.aw-r__valor[aria-pressed="true"]{background:#121212;color:#fff;border-color:#121212}' +
    '.aw-r__valor:disabled{color:#9a9a9a;border-color:#e6e6e6;text-decoration:line-through;cursor:not-allowed;background:#fafafa}' +
    '.aw-r__valor:focus-visible{outline:2px solid #121212;outline-offset:2px}' +
    '.aw-r__cta{margin:16px 0 0;height:54px;flex:none;border-radius:999px;border:0;background:#121212;color:#fff;font-family:inherit;font-size:15px;font-weight:700;cursor:pointer;transition:background .15s,color .15s}' +
    '.aw-r__cta:disabled{background:#ededed;color:#555;cursor:not-allowed}' +
    '.aw-r__cta.is-ocupado{opacity:.75;cursor:progress}' +
    '.aw-r__aviso{margin:8px 0 0;font-size:13px;font-weight:600;color:#c62828;text-align:center}.aw-r__aviso[hidden]{display:none}' +
    '.aw-r__envio{display:flex;justify-content:center;align-items:center;flex-wrap:wrap;gap:8px 12px;margin-top:14px;font-size:13px;line-height:1.3;color:#121212}' +
    '.aw-r__envio>span{display:inline-flex;align-items:center;gap:8px}.aw-r__envio b{font-weight:700}' +
    '.aw-r__bandeira{display:inline-flex;width:21px;height:14px;border-radius:3px;overflow:hidden;box-shadow:0 0 0 1px rgba(0,0,0,.12)}' +
    '.aw-r__sep{width:1px;height:16px;background:#d4d4d4}' +
    'html.aw-r-aberta,html.aw-r-aberta body{overflow:hidden}' +
    '@media screen and (min-width:750px){' +
      '.aw-r{align-items:center;padding:24px}' +
      '.aw-r__folha{max-width:480px;max-height:calc(100% - 48px);border-radius:24px;padding:14px 24px 24px;transform:translateY(24px);opacity:0;transition:transform .28s ease,opacity .28s ease}' +
      '.aw-r.is-aberta .aw-r__folha{opacity:1}' +
      '.aw-r__pega{display:none}' +
      '.aw-r__fotos{margin:14px -24px 0;padding:0 24px}' +
    '}' +
    '@media (prefers-reduced-motion:reduce){.aw-r__fundo,.aw-r__folha{transition:none}}';
  var st = document.createElement('style');
  st.setAttribute('data-aw-rapido', '');
  st.textContent = css;
  document.head.appendChild(st);

  var SVG_X = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var SVG_REGUA = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="2.5" y="8" width="19" height="8" rx="1.5"/><path d="M6.5 8v3M10 8v4.5M13.5 8v3M17 8v4.5"/></svg>';
  var SVG_BANDEIRA = '<svg width="21" height="14" viewBox="0 0 30 20" role="img" aria-label="Portugal"><rect width="12" height="20" fill="#046A38"/><rect x="12" width="18" height="20" fill="#DA291C"/><circle cx="12" cy="10" r="4.6" fill="#FFE000"/><path d="M10.2 7.6h3.6v3.2a1.8 1.8 0 0 1-3.6 0z" fill="#FFFFFF" stroke="#DA291C" stroke-width="0.7"/></svg>';
  var SVG_CAMIAO = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2.5 6.5h11v10h-11z"/><path d="M13.5 10h4l3 3.2v3.3h-7z"/><circle cx="6.5" cy="17.5" r="1.7"/><circle cx="17" cy="17.5" r="1.7"/></svg>';

  /* ====== utilidades ====== */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function dinheiro(cents) {
    var n = Math.round(Number(cents) || 0);
    var neg = n < 0; n = Math.abs(n);
    var eur = String(Math.floor(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var cen = ('0' + (n % 100)).slice(-2);
    return (neg ? '−' : '') + '€' + eur + ',' + cen;
  }
  function imagem(url, largura) {
    if (!url) { return ''; }
    url = String(url).replace(/^\/\//, 'https://');
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + largura;
  }
  function dataEnvio() {
    var d = new Date(), k = 0;
    while (k < DIAS_ENVIO) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) { k++; } }
    var DS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
    return DS[d.getDay()] + ', ' + ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2);
  }
  function nomeOpcao(o) { return (o && typeof o === 'object') ? o.name : o; }   /* /products/x.js traz {name, position, values} */
  function valoresOpcao(product, i) {
    var o = product.options[i];
    if (o && typeof o === 'object' && o.values) { return o.values.slice(); }
    var vistos = [];
    product.variants.forEach(function (v) { var x = v['option' + (i + 1)]; if (vistos.indexOf(x) < 0) { vistos.push(x); } });
    return vistos;
  }
  function pareceNumero(vals) {
    var n = 0;
    vals.forEach(function (v) { if (/^\d{2}(?:[.,]5)?$/.test(String(v).trim())) { n++; } });
    return vals.length && n >= vals.length - 1;
  }
  function rotuloDe(nome, vals) {
    if (SIZE.test(nome)) { return 'Escolhe o tamanho' + (pareceNumero(vals) ? '<span>&nbsp;· EU</span>' : ''); }
    if (COR.test(nome)) { return 'Escolhe a cor'; }
    return 'Escolhe: ' + esc(nome);
  }

  /* ====== estado ====== */
  var raiz = null, folha = null, aberto = null, timerFechar = null, guiaPedido = false;

  /* ====== intercetar o clique (fase de captura: apanha o modal-opener e o product-form) ====== */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.quick-add__submit, .quick-add [name="add"]');
    if (!btn) { return; }
    var qa = btn.closest('.quick-add, .complementary-products');
    if (!qa) { return; }
    e.preventDefault();
    e.stopImmediatePropagation();

    var url = btn.dataset.productUrl;
    if (!url) {
      var card = btn.closest('.card-wrapper, .product-card-wrapper, .complementary-slide, .grid__item, li');
      var a = card && card.querySelector('a[href*="/products/"]');
      url = a ? a.getAttribute('href') : null;
    }
    if (!url) { return; }
    var handle = url.split('/products/')[1];
    if (!handle) { return; }
    handle = handle.split('?')[0].split('#')[0];

    var lbl = btn.querySelector('.main-atc__label__text');
    var orig = lbl ? lbl.textContent : null;
    btn.disabled = true;
    if (lbl) { lbl.textContent = '…'; }
    function repor() { btn.disabled = false; if (lbl && orig !== null) { lbl.textContent = orig; } }

    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        repor();
        if (!p || !p.variants || !p.variants.length) { return; }
        if (p.variants.length === 1) { adicionar(p.variants[0].id, { btn: btn }); return; }
        abrir(p, btn);
      })
      .catch(repor);
  }, true);

  /* rede de segurança: o formulário do cartão nunca se submete sozinho */
  document.addEventListener('submit', function (e) {
    if (!e.target.closest || !e.target.closest('.quick-add, .complementary-products')) { return; }
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);

  /* ====== a janela ====== */
  function criar() {
    if (raiz) { return; }
    raiz = document.createElement('div');
    raiz.className = 'aw-r';
    raiz.hidden = true;
    raiz.innerHTML = '<div class="aw-r__fundo" data-aw-r-fechar></div>' +
      '<form class="aw-r__folha" role="dialog" aria-modal="true" aria-label="Escolher o tamanho" novalidate></form>';
    document.body.appendChild(raiz);
    folha = raiz.querySelector('.aw-r__folha');
    folha.addEventListener('submit', function (e) { e.preventDefault(); });
    raiz.addEventListener('click', function (e) {
      if (e.target.closest('[data-aw-r-fechar]')) { fechar(); return; }
      var v = e.target.closest('.aw-r__valor');
      if (v && !v.disabled) { escolher(v); return; }
      var cta = e.target.closest('.aw-r__cta');
      if (cta && !cta.disabled && aberto && aberto.variante) { adicionar(aberto.variante.id, { cta: cta }); return; }
      var g = e.target.closest('[data-aw-guia-abrir]');
      if (g && !window.__awGuiaTamanhos) { guiaPedido = true; carregarGuia(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && aberto && !document.documentElement.classList.contains('aw-g-aberto')) { fechar(); }
    });
  }

  function abrir(product, btn) {
    criar();
    clearTimeout(timerFechar);
    var opcoes = product.options.map(function (o, i) { return { nome: nomeOpcao(o), valores: valoresOpcao(product, i), pos: i + 1 }; });
    var escolhas = {};
    opcoes.forEach(function (o) { if (o.valores.length === 1) { escolhas[o.pos] = o.valores[0]; } });   /* opções com um só valor ficam logo escolhidas */
    aberto = { product: product, opcoes: opcoes, escolhas: escolhas, variante: null, origem: btn };

    var precos = product.variants.map(function (v) { return v.price; });
    var minP = Math.min.apply(null, precos), maxP = Math.max.apply(null, precos);
    var maisBarata = product.variants.filter(function (v) { return v.price === minP; })[0];
    var antesIni = (maisBarata && maisBarata.compare_at_price > minP) ? maisBarata.compare_at_price : 0;
    var fotos = (product.images || []).slice(0, 8);
    var imgPrincipal = (product.featured_image || fotos[0] || '');
    var temTamanho = opcoes.some(function (o) { return SIZE.test(o.nome) && o.valores.length > 1; });
    var temGuia = temTamanho && !!CFG.guiaJs && !!CFG.tabelas && !ACESSORIO.test(product.title || '');
    var nomeTamanho = temTamanho ? opcoes.filter(function (o) { return SIZE.test(o.nome) && o.valores.length > 1; })[0].nome : '';

    var h = '<div class="aw-r__pega" aria-hidden="true"></div>' +
      '<div class="aw-r__topo">' +
        (imgPrincipal ? '<img class="aw-r__img" src="' + esc(imagem(imgPrincipal, 160)) + '" alt="" width="60" height="60">' : '<span class="aw-r__img" aria-hidden="true"></span>') +
        '<div class="aw-r__nome-preco"><p class="aw-r__nome">' + esc(product.title) + '</p>' +
        '<p class="aw-r__preco"><span data-aw-r-preco>' + (minP !== maxP ? esc(TXT.desde) : '') + dinheiro(minP) + '</span><s data-aw-r-antes' + (antesIni ? '>' + dinheiro(antesIni) : ' hidden>') + '</s></p></div>' +
        '<button type="button" class="aw-r__x" aria-label="' + esc(TXT.fechar) + '" data-aw-r-fechar>' + SVG_X + '</button>' +
      '</div>' +
      (fotos.length > 1 ? '<div class="aw-r__fotos">' + fotos.map(function (u, i) { return '<img src="' + esc(imagem(u, 300)) + '" alt="' + esc(product.title) + ' — foto ' + (i + 1) + '" width="112" height="112" loading="lazy">'; }).join('') + '</div>' : '');

    /* 21/10: a cor aparece sempre por cima e só depois o tamanho (a ordem interna das opções não muda) */
    var ordemVisual = opcoes.filter(function (o) { return COR.test(o.nome); }).concat(opcoes.filter(function (o) { return !COR.test(o.nome); }));
    ordemVisual.forEach(function (o) {
      if (o.valores.length < 2) { return; }
      var numeros = pareceNumero(o.valores);
      var longos = o.valores.some(function (v) { return String(v).length > 6; });
      h += '<div class="aw-r__grupo" role="group" aria-labelledby="aw-r-rot-' + o.pos + '" data-aw-r-pos="' + o.pos + '">' +
        '<div class="aw-r__grupo-topo"><span class="aw-r__rotulo" id="aw-r-rot-' + o.pos + '">' + rotuloDe(o.nome, o.valores) + '</span>' +
        (SIZE.test(o.nome) && temGuia ? '<button type="button" class="aw-r__guia" data-aw-guia-abrir data-aw-opcao="' + esc(o.nome) + '" aria-haspopup="dialog">' + SVG_REGUA + '<span>' + esc(TXT.guia) + '</span></button>' : '') +
        '</div><div class="aw-r__valores' + (numeros ? ' aw-r__valores--numeros' : (longos ? ' aw-r__valores--texto' : '')) + '">' +
        o.valores.map(function (v) {
          var disp = product.variants.some(function (va) { return va['option' + o.pos] === v && va.available; });
          return '<button type="button" class="aw-r__valor" data-aw-r-pos="' + o.pos + '" data-aw-r-valor="' + esc(v) + '" aria-pressed="false"' + (disp ? '' : ' disabled aria-label="' + esc(v) + ' — ' + esc(TXT.esgotado) + '"') + '>' + esc(v) + '</button>';
        }).join('') + '</div></div>';
    });

    h += '<button type="button" class="aw-r__cta" disabled>' + esc(temTamanho ? TXT.escolhe : TXT.escolheVarios) + '</button>' +
      '<p class="aw-r__aviso" role="alert" hidden></p>' +
      '<div class="aw-r__envio"><span><span class="aw-r__bandeira">' + SVG_BANDEIRA + '</span><span>' + esc(TXT.enviado) + ' <b>' + esc(dataEnvio()) + '</b></span></span>' +
      '<span class="aw-r__sep" aria-hidden="true"></span><span>' + SVG_CAMIAO + esc(TXT.gratis) + '</span></div>';

    /* configuração do guia de tamanhos (o aware-guia-tamanhos.js lê o 1.º script[data-aw-guia-cfg] dentro do form) */
    if (temGuia) {
      var sh = ('0' + (product.id % 31)).slice(-2);
      var fatia = String(CFG.tabelas).replace(/aware-medidas-tabelas\.json.*$/, 'aware-medidas-' + sh + '.json');
      var cfg = { id: product.id, titulo: product.title, fatia: fatia, tabelas: CFG.tabelas, editor: !!CFG.editor,
        opcoes: opcoes.map(function (o) { return { nome: o.nome, valores: o.valores }; }) };
      h += '<script type="application/x-aw-guia" data-aw-guia-cfg>' + JSON.stringify(cfg).replace(/</g, '\\u003c') + '</scr' + 'ipt>';
      carregarGuia();
    }

    folha.innerHTML = h;
    folha.setAttribute('aria-label', temTamanho ? 'Escolher o tamanho' : 'Escolher as opções');
    folha.scrollTop = 0;
    atualizar();

    window.__awEscolherTamanho = function (valor) {           /* o guia de tamanhos escolhe aqui e não na página */
      if (!aberto || !nomeTamanho) { return false; }
      var b = Array.prototype.filter.call(folha.querySelectorAll('.aw-r__valor'), function (x) { return x.getAttribute('data-aw-r-valor') === String(valor); })[0];
      if (!b || b.disabled) { return false; }
      escolher(b);
      return true;
    };

    raiz.hidden = false;
    document.documentElement.classList.add('aw-r-aberta');
    requestAnimationFrame(function () { requestAnimationFrame(function () { raiz.classList.add('is-aberta'); }); });
    var primeiro = folha.querySelector('.aw-r__valor:not(:disabled)') || folha.querySelector('.aw-r__x');
    if (primeiro) { try { primeiro.focus({ preventScroll: true }); } catch (x) { /* nada */ } }
  }

  function escolher(b) {
    var pos = b.getAttribute('data-aw-r-pos'), v = b.getAttribute('data-aw-r-valor');
    var grupo = b.closest('.aw-r__grupo');
    Array.prototype.forEach.call(grupo.querySelectorAll('.aw-r__valor'), function (x) { x.setAttribute('aria-pressed', 'false'); });
    b.setAttribute('aria-pressed', 'true');
    aberto.escolhas[pos] = v;
    aviso('');
    atualizar();
  }

  function atualizar() {
    if (!aberto) { return; }
    var o = aberto, cta = folha.querySelector('.aw-r__cta');
    /* com outras opções já escolhidas, risca os valores que não existem/estão esgotados nessa combinação
       (duas passagens: limpar uma escolha que ficou esgotada pode mudar as outras) */
    for (var passagem = 0; passagem < 2; passagem++) {
      o.opcoes.forEach(function (op) {
        Array.prototype.forEach.call(folha.querySelectorAll('.aw-r__valor[data-aw-r-pos="' + op.pos + '"]'), function (b) {
          var val = b.getAttribute('data-aw-r-valor');
          var ha = o.product.variants.some(function (va) {
            if (va['option' + op.pos] !== val || !va.available) { return false; }
            return o.opcoes.every(function (op2) { return op2.pos === op.pos || !o.escolhas[op2.pos] || va['option' + op2.pos] === o.escolhas[op2.pos]; });
          });
          b.disabled = !ha;
          if (!ha && o.escolhas[op.pos] === val) { delete o.escolhas[op.pos]; b.setAttribute('aria-pressed', 'false'); }
        });
      });
    }
    var faltam = o.opcoes.filter(function (op) { return !o.escolhas[op.pos]; });
    if (faltam.length) {
      o.variante = null;
      cta.disabled = true;
      cta.textContent = faltam.length > 1 ? TXT.escolheVarios : (SIZE.test(faltam[0].nome) ? TXT.escolhe : (COR.test(faltam[0].nome) ? 'Escolhe a cor' : 'Escolhe: ' + faltam[0].nome));
      return;
    }
    var v = o.product.variants.filter(function (va) { return o.opcoes.every(function (op) { return va['option' + op.pos] === o.escolhas[op.pos]; }); })[0];
    o.variante = v && v.available ? v : null;
    var precoEl = folha.querySelector('[data-aw-r-preco]'), antesEl = folha.querySelector('[data-aw-r-antes]');
    if (v) {
      precoEl.textContent = dinheiro(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) { antesEl.textContent = dinheiro(v.compare_at_price); antesEl.hidden = false; } else { antesEl.hidden = true; }
    }
    if (!o.variante) { cta.disabled = true; cta.textContent = TXT.indisponivel; return; }
    cta.disabled = false;
    cta.textContent = TXT.adicionar + ' · ' + dinheiro(v.price);
  }

  function aviso(txt) {
    var p = folha && folha.querySelector('.aw-r__aviso');
    if (!p) { return; }
    p.textContent = txt || '';
    p.hidden = !txt;
  }

  function fechar() {
    if (!raiz || raiz.hidden) { return; }
    raiz.classList.remove('is-aberta');
    document.documentElement.classList.remove('aw-r-aberta');
    window.__awEscolherTamanho = null;
    var origem = aberto && aberto.origem;
    aberto = null;
    timerFechar = setTimeout(function () { raiz.hidden = true; folha.innerHTML = ''; }, 340);
    if (origem && origem.focus) { try { origem.focus({ preventScroll: true }); } catch (x) { /* nada */ } }
  }

  /* ====== guia de tamanhos (carregado só quando faz falta) ====== */
  function carregarGuia() {
    if (!CFG.guiaJs || window.__awGuiaTamanhos || document.querySelector('script[data-aw-guia-src]')) { return; }
    if (CFG.guiaCss && !document.querySelector('link[href="' + CFG.guiaCss + '"]')) {
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = CFG.guiaCss; document.head.appendChild(l);
    }
    var s = document.createElement('script');
    s.src = CFG.guiaJs; s.defer = true; s.setAttribute('data-aw-guia-src', '');
    s.onload = function () {
      if (guiaPedido && aberto) { guiaPedido = false; var g = folha.querySelector('[data-aw-guia-abrir]'); if (g) { g.click(); } }
    };
    document.head.appendChild(s);
  }

  /* ====== adicionar ao carrinho ====== */
  function adicionar(variantId, ui) {
    var cta = ui && ui.cta, btn = ui && ui.btn;
    if (cta) { cta.disabled = true; cta.classList.add('is-ocupado'); cta.textContent = TXT.aAdicionar; }
    var lbl = btn && btn.querySelector('.main-atc__label__text'), orig = lbl ? lbl.textContent : null;
    if (btn) { btn.disabled = true; if (lbl) { lbl.textContent = '…'; } }
    function reporBotao() { if (btn) { btn.disabled = false; if (lbl && orig !== null) { lbl.textContent = orig; } } }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      /* pede logo o carrinho desenhado, para o abrir já atualizado */
      body: JSON.stringify({ id: variantId, quantity: 1, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
    .then(function (r) { return r.json(); })
    .then(function (res) {
      if (!res || res.status) {                           /* erro da Shopify (ex.: esgotou entretanto) */
        var m = (res && (res.description || res.message)) || TXT.erro;
        if (cta) { cta.classList.remove('is-ocupado'); cta.disabled = true; cta.textContent = TXT.indisponivel; aviso(m); }
        reporBotao();
        return;
      }
      fechar();
      reporBotao();
      ['cart:refresh', 'cart:added'].forEach(function (ev) {
        document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
      });
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.classList.remove('is-empty');
        if (res.sections && typeof drawer.renderContents === 'function') { drawer.renderContents(res); }
        else if (typeof drawer.open === 'function') { drawer.open(btn || null); }
      }
      if (lbl) { lbl.textContent = '✓'; setTimeout(function () { lbl.textContent = orig; }, 1800); }
      fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
        var html = s['cart-icon-bubble']; if (!html) { return; }
        var t = document.createElement('div'); t.innerHTML = html;
        var nb = t.querySelector('.cart-count-bubble'), ob = document.querySelector('.cart-count-bubble');
        if (nb && ob) { ob.outerHTML = nb.outerHTML; }
      }).catch(function () { /* nada */ });
    })
    .catch(function () {
      if (cta) { cta.classList.remove('is-ocupado'); cta.disabled = false; cta.textContent = TXT.adicionar; aviso(TXT.erro); }
      reporBotao();
    });
  }
})();
